import CoachPodTable from './CoachPodTable';

export default CoachPodTable;
